import { Col, Row } from 'react-bootstrap';
import {
  HeadingDesc,
  HeadingWithSpace,
  SectionHeadingSmall
} from '../Headings';
import img from '../../assets/images/png/nwsletter.png';
import './newsLetter.css';
import SubscriptionInput from '../subscriptionInput/SubscriptionInput';

function NewsLetter() {
  return (
    <section className="newsletter">
      <Row>
        <Col md={3}>
          <div className="img_box">
            <img src={img} alt="img" />
          </div>
        </Col>
        <Col md={6}>
          <div className="content">
            <HeadingWithSpace text="MERI SEHAT NEWSLETTER" />
            <SectionHeadingSmall text="Feel empowered in your wellness journey. Sign up for our newsletter" />
            <HeadingDesc text="Get innovative health and wellness tips delivered to your inbox with our newsletter." />
            <SubscriptionInput />
          </div>
        </Col>
      </Row>
    </section>
  );
}

export default NewsLetter;
